import AppDisclaimer from '@/components/AppDisclaimer.vue';
import DispatcherComp from '@/components/DispatcherComp.vue';

import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/go-v2/:param',
    name: 'Go-V2',
    component: DispatcherComp,
    props: { source: 'GO' },
  },
  {
    path: '/tc-v2/:param',
    name: 'TC-V2',
    component: DispatcherComp,
    props: { source: 'TC', carrerpageorigin: 'TC' },
    beforeEnter: (to, from, next) => {
      if (to.query.carrerpageorigin !== 'TC') {
        const updatedQuery = { ...to.query, carrerpageorigin: 'TC' };
        next({ name: 'TC-V2', params: to.params, query: updatedQuery });
      } else {
        next();
      }
    },
  },
  {
    path: '/discl/',
    name: 'disclPath',
    component: DispatcherComp,
    props: { source: 'PY' },
    meta: { apiCall: true, extCall: true, disclPath:true },
    
  },
  {
    path: '/vb-v2/:param',
    name: 'Viber-V2',
    component: DispatcherComp,
    props: { isViber: true },
    meta: { apiCall: true, extCall: true },
  },
  {
    path: '/v2/:param([A-Za-z0-9]{5})',
    name: 'AlphaNumeric-V2',
    component: DispatcherComp,
    props: { source: 'PY' },
  },
  {
    path: '/go/:param',
    name: 'Go',
    component: DispatcherComp,
    props: { source: 'GO' },
    meta: { apiCall: true, extCall: true },
  },
  {
    path: '/ext/:param',
    name: 'Ext',
    component: DispatcherComp,
    props: { source: 'GO' },
    meta: { extCall: true },
  },
  {
    path: '/tc/:param',
    name: 'TC',
    component: DispatcherComp,
    props: { source: 'TC', carrerpageorigin: 'TC' },
    beforeEnter: (to, from, next) => {
      if (to.query.carrerpageorigin !== 'TC') {
        const updatedQuery = { ...to.query, carrerpageorigin: 'TC' };
        next({ name: 'TC', params: to.params, query: updatedQuery });
      } else {
        next();
      }
    },
    meta: { apiCall: true, extCall: true },
  },
  {
    path: '/vb/:param',
    name: 'Viber',
    component: DispatcherComp,
    props: { isViber: true },
    meta: { apiCall: true, extCall: true },
  },
  {
    path: '/new/:param([A-Za-z0-9]{5})',
    name: 'NewLoader',
    component: DispatcherComp,
    props: { source: 'NEW' },
  },

  {
    path: '/new/go/:param',
    name: 'NewGoLoader',
    component: DispatcherComp,
    props: { source: 'GO' },
  },

  {
    path: '/new/go-v2/:param',
    name: 'NewGoV2Loader',
    component: DispatcherComp,
    props: { source: 'GO' },
  },

  {
    path: '/new/tc-v2/:param',
    name: 'NewTcV2Loader',
    component: DispatcherComp,
    props: { source: 'TC' },
  },
  {
    path: '/:param([A-Za-z0-9]{5})',
    name: 'AlphaNumeric',
    component: DispatcherComp,
    props: { source: 'PY' },
  },
  /* -------  *one* catch-all for the new UI itself  --------------- */
  {
    /*  matches:
        /new/A4VTZ
        /new/go/1234567
        /new/go-v2/ABCDEF
        /new/tc-v2/42XYZ
    */
    path: '/new',
    name: 'AppDisclaimer',
    component: AppDisclaimer,
    // props: r => ({
    //   param: r.params.catchAll.toString().split('/').pop(), // GUID
    //   source: 'NEW'
    // }),
    beforeEnter: validateDisclaimerRoute,
  },
  {
    path: '/ai-disclaimer',
    name: 'aidisclaimer',
    component: DispatcherComp,
    props: (route) => ({
      param: route.query.param,
      // source: 'NEW'
    }),
    meta: { aiDisclaimer: true },
    beforeEnter: validateDisclaimerRoute,
  },
  {
    path: '/apply-ai',
    name: 'applyAi',
    component: DispatcherComp,
    props: (route) => ({
      param: route.query.param,
      // source: 'NEW'
    }),
    meta: { aiDisclaimer: true },
    beforeEnter: validateDisclaimerRoute,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router validations for the disclaimer route.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function validateDisclaimerRoute(to: any, from: any, next: any) {
  const updatedQuery: Record<string, string> = {};
  let needsRedirect = false;

  for (const key in to.query) {
    if (Object.prototype.hasOwnProperty.call(to.query, key)) {
      const value = to.query[key];
      updatedQuery[key] = Array.isArray(value) ? value[0] : value;

      // Detect duplicated query key
      if (Array.isArray(value)) {
        needsRedirect = true;
      }
    }
  }

  // Enforce aiDisclaimer=true only on /disclaimer (not param path)
  if (to.path === '/disclaimer') {
    if (updatedQuery.aiDisclaimer !== 'true') {
      updatedQuery.aiDisclaimer = 'true';
      needsRedirect = true;
    }
  }

  // Redirect only if something changed
  if (needsRedirect) {
    return next({ path: to.path, query: updatedQuery, params: to.params });
  }

  next();
}

export default router;
